import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitSwitchingFYear = createSelector(
  [selectFinancialCockpitState],
  ({ switchingFYear }) => switchingFYear?.fYear ?? null
)
